let configurazione = {
    urlBackend: "https://relazioni-ambiente-priv.regione.liguria.it/api/",
    urlApplicativo: "https://relazioni-ambiente-priv.regione.liguria.it/",
    token: "0a354e25-4aa8-3897-9d89-b9fff651e212",
    deployContext: "PRODUZIONE",
    pathRadice: "relazioneStatoAmbiente",
    tipoAmbiente: "FO"
}

export default configurazione;